import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConventionRegistration } from 'app/models/convention-registration.model';
import { DeleteConventionRegistrationHistory } from 'app/models/delete-convention-registration-history.model';
import { BadgeExtension } from 'app/models/extensions/badge-extension.model';

export class Badge extends BadgeExtension {
  badgeDBID: number = 0;
  badgeLine1: string = null;
  badgeLine2: string = null;
  badgeLine3: string = null;
  badgeLine4: string = null;
  badgeLine5: string = null;
  isPrinted: boolean = false;
  badgePrintDT?: Date = null;
  createdDT: Date = new Date();
  createdBy: string = null;
  modifiedDT: Date = new Date();
  modifiedBy: string = null;
  rowVersion: number = 0;
  conventionRegistrations: ConventionRegistration[] = [];
  deleteConventionRegistrationHistories: DeleteConventionRegistrationHistory[] = [];

  static getForm(disableAll: boolean = false, includeNav: string[] = []): FormGroup {
    const form = new FormGroup({
      badgeDBID: new FormControl({ value: 0, disabled: disableAll }),
      badgeLine1: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(255)]),
      badgeLine2: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(255)]),
      badgeLine3: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(255)]),
      badgeLine4: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(255)]),
      badgeLine5: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(255)]),
      isPrinted: new FormControl({ value: false, disabled: disableAll }, [Validators.required]),
      badgePrintDT: new FormControl({ value: null, disabled: disableAll }),
      createdDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      createdBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      modifiedDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      modifiedBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      rowVersion: new FormControl({ value: 0, disabled: disableAll }),
      conventionRegistrations: new FormArray([]),
      deleteConventionRegistrationHistories: new FormArray([])
    });


    return form;
  }
}